<template>
      <div v-if="show">
        <table style="background: #ccc;text-align: center;" >
          <thead>
          <!--表头-->
          <tr style="height: 40px;background: #aaa;width: 100%;">
            <th v-for="label in labelList">{{label}}</th>
          </tr>
          </thead>
          <tbody>
          <!--表体-->
          <tr v-for="item1 in dataList" :key="item1.id" style="height: 40px;">
            <td v-for="item in propList" v-if="isHaveElement(item)" >{{item1[item]}}</td>
            <td v-for="item in propList" v-if="item!==''&&item1[item]===undefined&&item===undefined"></td>
            <td>
              <slot/>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
</template>

<script>
    export default {
        props:{
          data:{type:Array}
        },
      data(){
        return{
          show:false,
          dataList:[],// 数据列表
          titleData:[],// 表头数组
          propList:[],// 用户定义的prop数据数组
          labelList:[],// 用户定义的label数据数组
          width:[],// 表格宽度
        }
      },
      watch:{
        data: function (data) {// 监听data，当data有数据时再展示页面
          this.$store.commit('New_Data', this.data);
          if (data) {
            this.show = true;
            this.dataList = this.data;
            this.$nextTick(() => {
              let props = this.$store.state.props;
              this.propList = Array.from(new Set(props));
              let labels = this.$store.state.labels;
              this.labelList = Array.from(new Set(labels));
              let width = this.$store.state.width;
              this.width = width.slice(0,this.labelList.length);
            });
            let dataList = this.dataList;
            for (let i = 0; i < 1; i++) {
              let map = dataList[0];
              let strMap = this.jsonChangeMap(map);
              let keys = [];
              keys = this.getMapKeysList(strMap);
              this.titleData = keys;
            }
          }
        }
      },
      methods:{
        isHaveElement(item){// 判断数组中是否包含某个元素
          let con = this.titleData.includes(item); // 表头的数据元素是否在用户需要展示的数组中，有就展示，没有的不展示
          return con;
        },
        jsonChangeMap(map){// json对象转为map集合
          let strMap = new Map();
          for(let k of Object.keys(map)){
            strMap.set(k,map[k]);
          }
          return strMap;
        },
        getMapKeysList(strMap){// 获取map的key添加到数组中
          let keys = [];
          for(let key of strMap.keys()){
            keys.push(key);
          }
          return keys;
        },
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/table.vue